// v-parallax="factor": translates the element vertically by a fraction of
// the current scroll position (default 0.3), so it drifts slower than the
// foreground content instead of staying perfectly static. Transform-driven
// (not background-attachment:fixed), so it stays smooth on mobile Safari.
//
// The offset is capped at BLEED_PX (drift eases to a stop rather than
// growing forever on long pages) and .parallax-backdrop in app.css is sized
// with that same amount of extra bleed above/below, so the backdrop always
// fully covers the viewport no matter how far down the page you scroll -
// otherwise translating a viewport-sized fixed layer eventually uncovers a
// plain, untextured gap at the top.
export const BLEED_PX = 150;

const prefersReducedMotion = () =>
	window.matchMedia('(prefers-reduced-motion: reduce)').matches;

export default {
	mounted(el, binding) {
		if (prefersReducedMotion()) return;

		const factor = typeof binding.value === 'number' ? binding.value : 0.3;
		let ticking = false;

		const update = () => {
			const offset = Math.min(window.scrollY * factor, BLEED_PX);
			el.style.transform = `translate3d(0, ${offset}px, 0)`;
			ticking = false;
		};

		const onScroll = () => {
			if (ticking) return;
			ticking = true;
			requestAnimationFrame(update);
		};

		update();
		window.addEventListener('scroll', onScroll, { passive: true });
		el.__parallaxCleanup = () => window.removeEventListener('scroll', onScroll);
	},
	unmounted(el) {
		el.__parallaxCleanup?.();
	},
};
